/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ClearingTicketFareDto = {
    id: string;
    /**
     * Clearing device id
     */
    clearingDeviceId: string;
    /**
     * DateTime when ticket fare cleared. Type: 'DATETIME'
     */
    date: string;
    /**
     * Token for clearing ticket fare.
     */
    token?: string;
    orderId?: number;
    tokenType: ClearingTicketFareDto.tokenType;
    transactionType: ClearingTicketFareDto.transactionType;
    amountType: ClearingTicketFareDto.amountType;
    /**
     * Ticket fare amount. Value is in cents
     */
    amount: number;
    /**
     * Ticket fare VAT.
     */
    vat?: number;
    customerProfileNumber?: number;
    tariffProfileNumber?: number;
    validFrom: string;
    validTo: string;
    tranRet: string;
};
export namespace ClearingTicketFareDto {
    export enum tokenType {
        MOBILE_APP = 'MOBILE_APP',
        BANKCARD = 'BANKCARD',
        JIHLAVA_CARD = 'JIHLAVA_CARD',
        IN_CARD = 'IN_CARD',
    }
    export enum transactionType {
        FARE = 'FARE',
        TICKET = 'TICKET',
        CANCEL = 'CANCEL',
        RETURN = 'RETURN',
        MOVE = 'MOVE',
        BLOCK = 'BLOCK',
    }
    export enum amountType {
        CASH = 'CASH',
        BANKCARD = 'BANKCARD',
        CARD = 'CARD',
        PREPAID = 'PREPAID',
    }
}

